import { colors } from '@/pages/dashboard/utils/colors'
import { Card } from '@material-tailwind/react'
import PropTypes from 'prop-types'

const boxColors = Object.freeze({
  default: [],
  green: ['border-green-700', 'bg-green-50'],
  yellow: ['border-yellow-700', 'bg-yellow-50'],
  orange: ['border-orange-700', 'bg-orange-50'],
  red: ['border-red-700', 'bg-red-50']
})

export const Box = ({ children, color, className, style }) => {
  const defaultClassName = ['border', 'shadow-none', 'p-4', 'rounded-xl']

  const customClassName = [
    ...defaultClassName,
    ...className.split(' ')
  ].join(' ')

  return (
    <div className={customClassName} style={style}>
      {children}
    </div>
  )
}

Box.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  color: PropTypes.oneOf(['green', 'yellow', 'orange', 'red', 'default'])
}

Box.defaultProps = {
  className: '',
  color: 'default'
}
